import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Box,
  Text,
  HStack,
  Flex,
  Button,
  IconButton,
  Divider,
  Grid,
  Badge,
  useToast,
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Tag,
  Icon,
  Link,
  ChakraProvider,
  Spinner,
  VStack,
} from "@chakra-ui/react";
import { CiSearch } from "react-icons/ci";
import {
  FaShieldAlt,
  FaFileAlt,
  FaRegCopy,
  FaFileDownload,
} from "react-icons/fa";
import { GoHistory } from "react-icons/go";
import { useEffect, useState } from "react";
import { cpfFormatter } from "@/utils/cpfFormatter";
import { BrlCurrencyFormatter } from "@/utils/BrlCurrencyFormatter";
import { format } from "date-fns";

import {  ProposalStatus, StatusRenderer } from "../ProposalTable/proposalStatusRenderer.tsx"
import {
  getFormalizationStatusLabel,
  getProposalStatusDescription,
  ProposalStatusType,
} from "@/utils/getProposalStatusLabel";
import { formatPhone } from "@/utils/formatPhone";
import {
  rejectProposal,
  getProposalById,
} from "@/services/proposal.service";
import { getFormalizationUrl } from "@/utils/formalizationUrl";
import FilePreview from "../FilePreview";
import BankDetailModal from "../BankDetailModal";
import BankAndPersonalDetailModal from "../BankAndPersonalDetailModal.ts";
import { useNavigate, useParams } from "react-router-dom";
import { Proposal } from "@/models/proposal.model.ts";
import createTheme from "../../theme/theme.ts";
// import BankAndPersonalDetailModal from "../BankAndPersonalDetailModal.ts";
// import BankDetailModal from "../BankDetailModal";
interface ProposalModalProps {
  isOpen: boolean;
  onClose: () => void;
  proposalId: string;
}

export default function ProposalModal({
  isOpen,
  onClose,
  proposalId,
}: ProposalModalProps) {

  const [activeTab, setActiveTab] = useState("");
  const { id: paramId } = useParams<{ id: string }>();
  
  const finalId = proposalId ?? paramId ?? null;
  const toast = useToast();
  // const getAssets = useWhiteLabelStore.getState().getAssets;
  // const { slug: urlSlug } = getAssets();
  const [ proposal, setProposal ] = useState<Proposal | null>(null);
  const [ isLoading, setIsLoading ] = useState(false);;

  const [isBankDetailFormOpen, setIsBankDetailFormOpen] = useState(false);
  const [isBankAndPersonalDetailFormOpen, setIsBankAndPersonalDetailFormOpen] = useState(false);
  const navigate = useNavigate();
  
  const computedIsOpen = isOpen ?? Boolean(paramId);
  const handleCloseModal = onClose ?? (() => {
    navigate("/propostas");
  });

  // const handleCloseModal = () => {
  //   setActiveTab("");
  //   onClose();
  // };

  useEffect(() => {
    if (!finalId) return;
    let alive = true;
    if (computedIsOpen) {
      setIsLoading(true);
      getProposalById(finalId)
        .then((data) => {
          if (alive) setProposal(data ?? null);
        })
        .catch((err) => console.error(err))
        .finally(() => {
          if (alive) setIsLoading(false);
        });
      return () => {
        alive = false;
      };
    }
  }, [computedIsOpen]);

  // if (!proposal) return null;

  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text);
    toast({
      title: "Copiado",
      description: "Texto copiado para a área de transferência.",
      status: "success",
      duration: 2000,
      isClosable: true,
    });
  };

  const handleCancelProposal = async (
    event: React.MouseEvent<HTMLButtonElement>,
    id: string
  ) => {
    event.stopPropagation();
    try {
      await rejectProposal(id);
      toast({
        title: "Proposta Cancelada",
        description: "Enviamos a proposta para cancelamento.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Erro ao Cancelar",
        description: "Ocorreu um erro ao cancelar a proposta.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const getModalSize = () => (activeTab === "seguranca" ? "2xl" : "xl");

  const getFormattedPixKey = () => {
    const pixKey = proposal?.BankDetail?.pixKey ?? "Não informado";
    const pixKeyType = proposal?.BankDetail?.pixKeyType;

    if (pixKeyType === "DOCUMENT") return cpfFormatter(pixKey);
    if (pixKeyType === "PHONE") return formatPhone(pixKey);

    return pixKey;
  };






  const theme = createTheme();
  return (
    <>
      <Modal isOpen={computedIsOpen} onClose={handleCloseModal} size={getModalSize()}>
        <ModalOverlay />
        <ModalContent
          borderRadius={{ base: "20px", md: "20px" }}
          overflow="hidden"
          maxW={{ base: "90%", md: "90%", lg: "800px" }}
        >
          {isLoading ? (
            <ChakraProvider theme={theme}>
              <Box
                height="100%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                padding="3em"
              >
                <VStack spacing={4}>
                  <Spinner size="xl" color="primary" thickness="4px" speed="0.65s" />
                  <Text fontSize="xl" fontWeight="medium">
                    Carregando...
                  </Text>
                </VStack>
              </Box>
            </ChakraProvider>
          ) : !proposal ? (
            <Box p={6}><Text>Proposta não encontrada.</Text></Box>
          ) : (<>
            {activeTab !== "" && (
              <Box
                bg="#58c46c"
                pt={2}
                pl={{ base: 3, md: 5 }}
                pb={2}
                borderTopRadius={{ base: "0", md: "20px" }}
              >
                <Text
                  color="white"
                  fontSize={{ base: "md", md: "sm" }}
                  fontFamily="Lexend Deca"
                >
                  Proposta
                </Text>
                <Text
                  color="white"
                  fontSize={{ base: "md", md: "lg" }}
                  fontFamily="Lexend Deca"
                >
                  {proposal?.NaturalPerson?.name}
                </Text>
              </Box>
            )}

            <Box
              bg="secondary"
              p={{ base: 3, md: 4 }}
              borderTopRadius={{ base: "0", md: activeTab === "" ? "20px" : "0" }}
            >
              <HStack
                justify="space-around"
                spacing={2}
                h={{ base: "auto", md: "50px" }}
                overflowX={{ base: "auto", md: "visible" }}
                flexWrap={{ base: "nowrap", md: "wrap" }}
              >
                <Flex
                  align="center"
                  color="white"
                  bgGradient="linear(to-b, rgba(0, 0, 0, 0.5), secondary)"
                  p={3}
                  borderRadius="10px"
                  mb={{ base: 2, md: 0 }}
                  w={{ base: "120px", md: "130px" }}
                  h={{ base: "40px", md: "30px" }}
                  justify="center"
                  boxShadow="sm"
                  cursor="pointer"
                  onClick={() => setActiveTab("visualizar")}
                >
                  <Icon as={CiSearch} boxSize={{ base: 5, md: 6 }} mr={2} />
                  <Text
                    fontSize={{ base: "md", md: "md" }}
                    fontFamily="Lexend Deca"
                  >
                    Visualizar
                  </Text>
                </Flex>

                <Flex
                  align="center"
                  color="white"
                  bgGradient="linear(to-b, rgba(0, 0, 0, 0.5), secondary)"
                  p={3}
                  borderRadius="10px"
                  mb={{ base: 2, md: 0 }}
                  w={{ base: "160px", md: "160px" }}
                  h={{ base: "40px", md: "30px" }}
                  boxShadow="sm"
                  cursor="pointer"
                  onClick={() => setActiveTab("seguranca")}
                  flexDirection="row"
                >
                  <Icon as={FaShieldAlt} boxSize={{ base: 5, md: 6 }} mr={2} />
                  <Text
                    fontSize={{ base: "md", md: "md" }}
                    fontFamily="Lexend Deca"
                  >
                    Formalização
                  </Text>
                </Flex>

                <Flex
                  align="center"
                  justify="space-around"
                  color="white"
                  bgGradient="linear(to-b, rgba(0, 0, 0, 0.5), secondary)"
                  p={3}
                  borderRadius="10px"
                  mb={{ base: 2, md: 0 }}
                  w={{ base: "130px", md: "130px" }}
                  h={{ base: "40px", md: "30px" }}
                  boxShadow="sm"
                  cursor="pointer"
                  onClick={() => setActiveTab("contrato")}
                >
                  <Icon as={FaFileAlt} boxSize={{ base: 5, md: 6 }} mr={2} />
                  <Text
                    fontSize={{ base: "md", md: "md" }}
                    fontFamily="Lexend Deca"
                  >
                    Contrato
                  </Text>
                </Flex>

                <Flex
                  align="center"
                  color="white"
                  bgGradient="linear(to-b, rgba(0, 0, 0, 0.5), secondary)"
                  p={3}
                  borderRadius="10px"
                  mb={{ base: 2, md: 0 }}
                  w={{ base: "130px", md: "130px" }}
                  h={{ base: "40px", md: "30px" }}
                  boxShadow="sm"
                  cursor="pointer"
                  onClick={() => setActiveTab("historico")}
                >
                  <Icon as={GoHistory} boxSize={{ base: 5, md: 6 }} mr={2} />
                  <Text
                    fontSize={{ base: "md", md: "md" }}
                    fontFamily="Lexend Deca"
                  >
                    Histórico
                  </Text>
                </Flex>
                {/* 
            EXLUIR ESSE BOTÃO
            <Flex
              align="center"
              color="white"
              bgGradient="linear(to-b, rgba(0, 0, 0, 0.5), secondary)"
              p={3}
              borderRadius="10px"
              mb={{ base: 2, md: 0 }}
              w={{ base: "130px", md: "130px" }}
              h={{ base: "40px", md: "30px" }}
              boxShadow="sm"
              cursor="pointer"
              onClick={() => setActiveTab("ações")}
            >
              <Icon as={GoZap} boxSize={{ base: 5, md: 6 }} mr={2} />
              <Text
                fontSize={{ base: "md", md: "md" }}
                fontFamily="Lexend Deca"
              >
                Ações
              </Text>
            </Flex> */}
              </HStack>
            </Box>

            <ModalBody p={{ base: 4, md: 6 }}>
              {activeTab === "" && (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexDirection="column"
                  width="100%"
                >
                  <Text
                    fontSize={{ base: "2xl", md: "4xl" }}
                    color="secondary"
                    fontFamily="Lexend Deca"
                    textAlign="center"
                    mb={2}
                  >
                    {proposal?.NaturalPerson?.name}
                  </Text>
                  <Flex align="center" justify="center" mb={2}>
                    <Text
                      fontSize={{ base: "2xl", md: "4xl" }}
                      color="secondary"
                      fontFamily="Lexend Deca"
                      textAlign="center"
                    >
                      CPF: {cpfFormatter(proposal?.NaturalPerson?.document!)}
                    </Text>
                    <IconButton
                      aria-label="Copiar CPF"
                      icon={<FaRegCopy />}
                      ml={2}
                      onClick={() =>
                        handleCopy(cpfFormatter(proposal?.NaturalPerson?.document!))
                      }
                      size={{ base: "xl", md: "sm" }}
                      variant="ghost"
                      color="gray.500"
                      alignSelf="center"
                    />
                  </Flex>


                  <Box width={{ base: "100%", md: "80%", lg: "400px" }} mt="1rem">
                    <Text
                      fontSize={{ base: "xl", md: "lg" }}
                      color="gray.400"
                      fontWeight="bold"
                      fontFamily="Lexend Deca"
                      display={
                        ["CANCELED", "CANCELED_BY_CLIENT", "REPROVED"].includes(
                          proposal?.status!
                        )
                          ? "flex"
                          : "none"
                      }
                    >
                      Motivo do cancelamento:
                    </Text>
                    <Flex
                      alignItems="center"
                      mb={4}
                      display={
                        ["CANCELED", "CANCELED_BY_CLIENT", "REPROVED"].includes(
                          proposal?.status!
                        )
                          ? "flex"
                          : "none"
                      }
                    >
                      <Text
                        fontSize={{ base: "md", md: "lg" }}
                        color="secondary"
                        fontFamily="Lexend Deca"
                      >
                        {getProposalStatusDescription(
                          proposal?.status! as ProposalStatusType
                        )}
                      </Text>
                      <IconButton
                        aria-label="Copiar Legenda da consulta"
                        ml={2}
                        icon={<FaRegCopy />}
                        onClick={() =>
                          handleCopy(
                            getProposalStatusDescription(
                              proposal?.status! as ProposalStatusType
                            )
                          )
                        }
                        size={{ base: "xl", md: "sm" }}
                        variant="ghost"
                        color="gray.500"
                      />
                    </Flex>
                    <Flex justify={"center"}>
                      {proposal.status !== "PENDING_USER_REVIEW" && (
                      <StatusRenderer
                        status={
                          ProposalStatus[
                            proposal.status as keyof typeof ProposalStatus
                          ]
                        }
                        customStatus={proposal.customStatus as string}
                      />
                    )}
                    </Flex>
                    {proposal?.status === "PENDING_USER_REVIEW" && proposal?.customStatus && (
                    <Flex justify={"center"}>
                      
                      
                       <StatusRenderer status={ProposalStatus[proposal.status as keyof typeof ProposalStatus]} customStatus={proposal?.customStatus!} />
                     
                    </Flex>
                    ) }
                    <Text
                      fontSize={{ base: "xl", md: "lg" }}
                      color="gray.400"
                      fontWeight="bold"
                      fontFamily="Lexend Deca"
                    >
                      Número da Proposta:
                    </Text>

                    <Flex alignItems="center" mb={4}>
                      <Text
                        fontSize={{ base: "xl", md: "lg" }}
                        color="secondary"
                        fontFamily="Lexend Deca"
                      >
                        {proposal?.shortHash}
                      </Text>
                      <IconButton
                        aria-label="Copiar Número da Proposta"
                        icon={<FaRegCopy />}
                        ml={2}
                        onClick={() => handleCopy(proposal?.shortHash!)}
                        size={{ base: "xl", md: "sm" }}
                        variant="ghost"
                        color="gray.500"
                      />
                    </Flex>
                    <Text
                      fontSize={{ base: "xl", md: "lg" }}
                      color="gray.400"
                      fontWeight="bold"
                      fontFamily="Lexend Deca"
                    >
                      Número da Proposta na Bancarizadora:
                    </Text>

                    <Flex alignItems="center" mb={4}>
                      <Text
                        fontSize={{ base: "xl", md: "lg" }}
                        color="secondary"
                        fontFamily="Lexend Deca"
                      >
                        {proposal?.externalId}
                      </Text>
                      <IconButton
                        aria-label="Copiar Número da Proposta"
                        icon={<FaRegCopy />}
                        ml={2}
                        onClick={() => handleCopy(proposal?.externalId!)}
                        size={{ base: "xl", md: "sm" }}
                        variant="ghost"
                        color="gray.500"
                      />
                    </Flex>
                    <Text
                      fontSize={{ base: "xl", md: "lg" }}
                      color="gray.400"
                      fontWeight="bold"
                      fontFamily="Lexend Deca"
                    >
                      Link de Formalização:
                    </Text>
                    <Flex alignItems="center" mt={2} flexWrap="nowrap">
                      <Text
                        fontSize={{ base: "xl", md: "lg" }}
                        color="secondary"
                        fontFamily="Lexend Deca"
                      >
                        {proposal?.UnicoData?.id
                          ? getFormalizationUrl(
                            proposal.UnicoData?.id,
                            proposal.Corban?.WhiteLabel?.slug
                          )
                          : "Erro ao obter link"}
                      </Text>
                      <IconButton
                        ml={2}
                        aria-label="Copiar Link de Formalização"
                        icon={<FaRegCopy />}
                        onClick={() =>
                          handleCopy(
                            proposal?.UnicoData?.id
                              ? getFormalizationUrl(
                                proposal.UnicoData?.id,
                                proposal.Corban?.WhiteLabel?.slug
                              )
                              : "Erro ao obter link"
                          )
                        }
                        size="sm"
                        variant="ghost"
                        color="gray.500"
                      />
                    </Flex>
                  </Box>
                </Box>
              )}


              {activeTab === "visualizar" && (
                <>
                  <VStack spacing={1} align="stretch">
                    <Flex
                      justify="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Titular:
                      </Text>
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {proposal?.NaturalPerson?.name ?? "Não informado"}
                      </Text>
                    </Flex>
                    <Divider borderColor="gray.500" borderWidth="1px" />
                    <Flex
                      justify="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        CPF Titular:
                      </Text>
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {proposal?.NaturalPerson?.document
                          ? cpfFormatter(proposal?.NaturalPerson?.document)
                          : "Não informado"}
                      </Text>
                    </Flex>
                    <Divider borderColor="gray.500" borderWidth="1px" />
                    <Flex
                      justify="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Tabela:{" "}
                      </Text>
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {proposal?.chosenFinancialInfo?.Product?.name || "-"}
                      </Text>
                    </Flex>
                    <Divider borderColor="gray.500" borderWidth="1px" />

                    {proposal?.BankDetail?.pixKeyType !== "BANK_ACCOUNT" && (
                      <>
                        <Flex
                          justify="space-between"
                          align="stretch"
                          flexDirection={{ base: "column", md: "row" }}
                        >
                          <Text
                            fontSize={{ base: "md", md: "md" }}
                            fontFamily="Lexend Deca"
                            color="gray.500"
                          >
                            Chave Pix:
                          </Text>
                          <Text
                            fontSize={{ base: "md", md: "md" }}
                            fontFamily="Lexend Deca"
                            color="gray.500"
                          >
                            {getFormattedPixKey()}
                          </Text>
                        </Flex>
                        <Divider borderColor="gray.500" borderWidth="1px" />
                      </>
                    )}

                    {proposal?.BankDetail?.pixKeyType === "BANK_ACCOUNT" && (
                      <>
                        <Flex
                          justify="space-between"
                          flexDirection={{ base: "column", md: "row" }}
                        >
                          <Text
                            fontSize={{ base: "sm", md: "md" }}
                            fontFamily="Lexend Deca"
                            color="gray.500"
                          >
                            Banco:
                          </Text>
                          <Text
                            fontSize={{ base: "sm", md: "md" }}
                            fontFamily="Lexend Deca"
                            color="gray.500"
                          >
                            {proposal?.BankDetail?.bankCode ?? "Não informado"}
                          </Text>
                        </Flex>
                        <Divider borderColor="gray.500" borderWidth="1px" />

                        <Flex
                          justify="space-between"
                          flexDirection={{ base: "column", md: "row" }}
                        >
                          <Text
                            fontSize={{ base: "sm", md: "md" }}
                            fontFamily="Lexend Deca"
                            color="gray.500"
                          >
                            Agência:
                          </Text>
                          <Text
                            fontSize={{ base: "sm", md: "md" }}
                            fontFamily="Lexend Deca"
                            color="gray.500"
                          >
                            {proposal?.BankDetail?.agency ?? "Não informado"}
                          </Text>
                        </Flex>
                        <Divider borderColor="gray.500" borderWidth="1px" />

                        <Flex
                          justify="space-between"
                          flexDirection={{ base: "column", md: "row" }}
                        >
                          <Text
                            fontSize={{ base: "sm", md: "md" }}
                            fontFamily="Lexend Deca"
                            color="gray.500"
                          >
                            Conta:
                          </Text>
                          <Text
                            fontSize={{ base: "sm", md: "md" }}
                            fontFamily="Lexend Deca"
                            color="gray.500"
                          >
                            {proposal?.BankDetail?.account ?? "Não informado"}
                          </Text>
                        </Flex>
                        <Divider borderColor="gray.500" borderWidth="1px" />

                        <Flex
                          justify="space-between"
                          flexDirection={{ base: "column", md: "row" }}
                        >
                          <Text
                            fontSize={{ base: "sm", md: "md" }}
                            fontFamily="Lexend Deca"
                            color="gray.500"
                          >
                            Dígito Verificador:
                          </Text>
                          <Text
                            fontSize={{ base: "sm", md: "md" }}
                            fontFamily="Lexend Deca"
                            color="gray.500"
                          >
                            {proposal?.BankDetail?.accountDigit ?? "Não informado"}
                          </Text>
                        </Flex>
                        <Divider borderColor="gray.500" borderWidth="1px" />
                      </>
                    )}
                    <Flex
                      justify="space-between"
                      width="100%"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Data da Proposta:
                      </Text>
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {proposal?.NaturalPerson?.updatedAt
                          ? format(
                            proposal?.NaturalPerson.updatedAt,
                            "dd/MM/yyyy - HH:mm"
                          )
                          : ""}
                      </Text>
                    </Flex>
                    <Divider borderColor="gray.500" borderWidth="1px" />
                    <Flex
                      justify="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Data de Formalização:
                      </Text>
                      <Text
                        fontSize={{ base: "md", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {proposal?.UnicoData?.lastFormalizationDate
                          ? format(
                            proposal?.UnicoData?.lastFormalizationDate,
                            "dd/MM/yyyy - HH:mm"
                          )
                          : ""}
                      </Text>
                    </Flex>
                    <Divider borderColor="gray.500" borderWidth="1px" />
                    <Flex
                      justify="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        Data do Pagamento:
                      </Text>
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        fontFamily="Lexend Deca"
                        color="gray.500"
                      >
                        {proposal?.disbursementDate
                          ? format(proposal?.disbursementDate, "dd/MM/yyyy - HH:mm")
                          : ""}
                      </Text>
                    </Flex>
                    <Divider borderColor="gray.500" borderWidth="1px" />
                  </VStack>

                  <Box
                    bg="secondary"
                    color="white"
                    mt={4}
                    p={{ base: 4, md: 6 }}
                    borderRadius="md"
                  >
                    <Text
                      fontFamily="Lexend Deca"
                      fontSize={{ base: "lg", md: "xl" }}
                      textAlign="center"
                    >
                      Resultado da Simulação
                    </Text>

                    <Grid
                      pl={{ base: 2, md: "4rem" }}
                      templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
                      gap={6}
                      mt={4}
                      justifyContent="center"
                    >
                      <Flex direction="column" align="start">
                        <Text
                          fontSize={{ base: "xl", md: "2xl" }}
                          fontFamily="Lexend Deca"
                        >
                          {BrlCurrencyFormatter(
                            proposal?.chosenFinancialInfo?.releasedAmount
                          )}
                        </Text>
                        <Text
                          fontSize={{ base: "sm", md: "md" }}
                          fontFamily="Lexend Deca"
                        >
                          VALOR LIBERADO AO CLIENTE
                        </Text>
                      </Flex>

                      <Flex direction="column" align="start">
                        <Text
                          fontSize={{ base: "xl", md: "2xl" }}
                          fontFamily="Lexend Deca"
                        >
                          {proposal?.anticipatedYears ?? "Erro ao obter anos"}
                        </Text>
                        <Text
                          fontSize={{ base: "sm", md: "md" }}
                          fontFamily="Lexend Deca"
                        >
                          ANOS ANTECIPADOS
                        </Text>
                      </Flex>

                      <Flex direction="column" align="start">
                        <Text
                          fontSize={{ base: "xl", md: "2xl" }}
                          fontFamily="Lexend Deca"
                        >
                          {BrlCurrencyFormatter(
                            proposal?.chosenFinancialInfo?.Installments?.slice(
                              0,
                              proposal?.anticipatedYears ?? undefined
                            ).reduce(
                              (acc, installment) => acc + installment.payment,
                              0
                            )
                          )}
                        </Text>
                        <Text
                          fontSize={{ base: "sm", md: "md" }}
                          fontFamily="Lexend Deca"
                        >
                          VALOR BLOQUEADO
                        </Text>
                      </Flex>

                      <Flex direction="column" align="start">
                        <Text
                          fontSize={{ base: "xl", md: "2xl" }}
                          fontFamily="Lexend Deca"
                        >
                          {(
                            proposal?.chosenFinancialInfo?.monthlyRate! * 100
                          )?.toFixed(2) ?? "XXXXX"}
                          %
                        </Text>
                        <Text
                          fontSize={{ base: "sm", md: "md" }}
                          fontFamily="Lexend Deca"
                        >
                          TAXA A.M.
                        </Text>
                      </Flex>
                    </Grid>

                    <Flex justify="center" mt={6}>
                      <Button
                        bg="white"
                        color="secondary"
                        fontFamily="Lexend Deca"
                        borderRadius="md"
                        _hover={{ bg: "#f5f5f5" }}
                        onClick={(event) =>
                          handleCancelProposal(event, proposal?.id!)
                        }
                        px={{ base: 4, md: 8 }}
                        w={{ base: "100%", md: "auto" }}
                        isDisabled={proposal?.status === ProposalStatus.CANCELED}
                      >
                        Cancelar Proposta
                      </Button>
                    </Flex>
                  </Box>
                </>
              )}

              {activeTab === "seguranca" && (
                <Box p={{ base: 2, md: 4 }}>
                  <Flex
                    align="center"
                    mb={4}
                    flexDirection={{ base: "column", md: "row" }}
                  >
                    <Text
                      fontSize={{ base: "2xl", md: "xl" }}
                      fontFamily="Lexend Deca"
                      color="gray.500"
                      mr={{ base: 0, md: 2 }}
                      mb={{ base: 2, md: 0 }}
                    >
                      Status Formalização:
                    </Text>
                    <Badge
                      bg="#58c46c"
                      color="white"
                      borderRadius="4px"
                      fontSize={{ base: "sm", md: "md" }}
                      p={{ base: "2px 6px", md: "4px 8px" }}
                    >
                      {getFormalizationStatusLabel(
                        proposal?.UnicoData?.unicoStatus!
                      )}
                    </Badge>
                  </Flex>

                  <Accordion allowMultiple>
                    <AccordionItem>
                      <AccordionButton>
                        <Box flex="1" textAlign="left">
                          <Text
                            fontSize={{ base: "lg", md: "xl" }}
                            fontFamily="Lexend Deca"
                            color="gray.500"
                          >
                            Documentos Formalização
                          </Text>
                        </Box>
                        <AccordionIcon />
                        <Text
                          fontSize={{ base: "md", md: "lg" }}
                          fontFamily="Lexend Deca"
                          color="gray.600"
                          ml={2}
                        >
                          Exibir
                        </Text>
                      </AccordionButton>
                      <AccordionPanel pb={4}>
                        {proposal?.UnicoData?.frontDocument && (
                          <Flex direction="column" align="center" gap={4}>
                            <Text
                              fontSize="md"
                              fontWeight="bold"
                              fontFamily="Lexend Deca"
                              color="gray.700"
                            >
                              Documento do Titular
                            </Text>

                            <Box
                              mt="1rem"
                              boxSize={{ base: "12.5rem", md: "18.75rem" }}
                              overflow="hidden"
                              borderRadius="md"
                              borderWidth="0.0625rem"
                            >
                              <FilePreview
                                fileUrl={proposal.UnicoData?.frontDocument}
                              />
                            </Box>
                          </Flex>
                        )}
                      </AccordionPanel>
                    </AccordionItem>
                  </Accordion>
                </Box>
              )}

              {activeTab === "contrato" && (
                <>
                  <Text
                    fontSize={{ base: "md", md: "lg" }}
                    fontFamily="Lexend Deca"
                    color="gray.500"
                    mb={4}
                  >
                    CONTRATO/PAGAMENTO
                  </Text>
                  <Flex
                    justify="space-between"
                    flexDirection={{ base: "column", md: "row" }}
                    gap={3}
                  >
                    {proposal?.Contract?.signedContractUrl && (
                      <Link
                        href={`https://docs.google.com/viewer?url=${encodeURIComponent(proposal.Contract.signedContractUrl)}&embedded=true`}
                        target="_blank"
                        rel="noopener noreferrer"
                        bg="secondary"
                        color="white"
                        borderRadius="full"
                        fontSize={{ base: "md", md: "lg" }}
                        fontFamily="Lexend Deca"
                        px={{ base: 6, md: 8 }}
                        py={2}
                        mb={{ base: 2, md: 0 }}
                        _hover={{ bg: "#064d60" }}
                        display="inline-flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Flex align="center" justify="center">
                          <Icon
                            as={FaFileDownload}
                            boxSize={{ base: 5, md: 6 }}
                            mr={3}
                          />
                          Contrato
                        </Flex>
                      </Link>
                    )}
                    {proposal?.Contract?.paymentReceipt && (
                      <Link
                        href={`https://docs.google.com/viewer?url=${encodeURIComponent(proposal.Contract.paymentReceipt)}&embedded=true`}
                        target="_blank"
                        rel="noopener noreferrer"
                        bg="#58c46c"
                        color="white"
                        borderRadius="full"
                        fontSize={{ base: "md", md: "lg" }}
                        fontFamily="Lexend Deca"
                        px={{ base: 6, md: 8 }}
                        py={2}
                        _hover={{ bg: "green.500" }}
                        display="inline-flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Flex align="center" justify="center">
                          <Icon
                            as={FaFileAlt}
                            boxSize={{ base: 5, md: 6 }}
                            mr={3}
                          />
                          Comprovante de pagamento
                        </Flex>
                      </Link>
                    )}
                  </Flex>
                </>
              )}

              {activeTab === "historico" && (
                <VStack align="start" spacing={4}>
                  {proposal?.OperationLog!.map((logItem, index) => (
                    <Box key={index} width="100%">
                      <Flex
                        justify="space-between"
                        width="100%"
                        alignItems="center"
                        flexDirection={{ base: "column", md: "row" }}
                      >
                        <Tag size="lg" colorScheme="blue" mb={{ base: 2, md: 0 }}>
                          {logItem.createdAt
                            ? new Date(logItem.createdAt).toLocaleString("pt-BR", {
                              dateStyle: "short",
                              timeStyle: "short",
                              hour12: false,
                            })
                            : ""}
                        </Tag>
                        <Text
                          fontSize={{ base: "sm", md: "md" }}
                          color="gray.500"
                          fontFamily="Lexend Deca"
                        >
                          {logItem.ownerType === "USER"
                            ? logItem.User?.name || ""
                            : "Sistema"}
                        </Text>
                      </Flex>
                      <Text
                        fontSize={{ base: "md", md: "lg" }}
                        fontWeight="bold"
                        fontFamily="Lexend Deca"
                        color="secondary"
                        mt={2}
                      >
                        {logItem.title}
                      </Text>
                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        color="gray.500"
                        fontFamily="Lexend Deca"
                      >
                        Observação: {logItem.message}
                      </Text>
                      {logItem.userId && (
                        <Text
                          fontSize={{ base: "sm", md: "md" }}
                          color="gray.500"
                          fontFamily="Lexend Deca"
                        >
                          UserID: {logItem.User?.name}
                        </Text>
                      )}
                      {logItem.proposalId && (
                        <Text
                          fontSize={{ base: "sm", md: "md" }}
                          color="gray.500"
                          fontFamily="Lexend Deca"
                        >
                          Id de proposta: {logItem.proposalId}
                        </Text>
                      )}
                      {logItem.balanceSolicitationId && (
                        <Text
                          fontSize={{ base: "sm", md: "md" }}
                          color="gray.500"
                          fontFamily="Lexend Deca"
                        >
                          Id Consulta de Saldo: {logItem.balanceSolicitationId}
                        </Text>
                      )}
                      <Divider />
                    </Box>
                  ))}
                </VStack>
              )}
              {activeTab === "ações" && (
                <Flex justify="center" gap={4}>
        
                </Flex>
              )}
            </ModalBody>
          </>)}
        </ModalContent>
      </Modal>
      <BankDetailModal
        isOpen={isBankDetailFormOpen}
        onClose={() => setIsBankDetailFormOpen(false)}
        proposalId={proposal?.id}
      />
      <BankAndPersonalDetailModal
        isOpen={isBankAndPersonalDetailFormOpen}
        onClose={() => setIsBankAndPersonalDetailFormOpen(false)}
        proposalId={proposal?.id}
      />
    </>
  );
}
